var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.025 20C3.42266 20 0.5 17.1205 0.5 13.5714C0.5 10.7679 2.32156 8.38393 4.85906 7.50446C4.85453 7.38393 4.85 7.26339 4.85 7.14286C4.85 3.19643 8.09438 0 12.1 0C14.787 0 17.1297 1.4375 18.3848 3.58036C19.0736 3.125 19.9073 2.85714 20.8 2.85714C23.2016 2.85714 25.15 4.77679 25.15 7.14286C25.15 7.6875 25.0458 8.20536 24.86 8.6875C27.5063 9.21429 29.5 11.5223 29.5 14.2857C29.5 17.442 26.9036 20 23.7 20H7.025ZM10.6047 10.3125C10.1788 10.7321 10.1788 11.4107 10.6047 11.8259C11.0306 12.2411 11.7194 12.2455 12.1408 11.8259L13.908 10.0848V16.0714C13.908 16.6652 14.3928 17.1429 14.9955 17.1429C15.5981 17.1429 16.083 16.6652 16.083 16.0714V10.0848L17.8502 11.8259C18.2761 12.2455 18.9648 12.2455 19.3862 11.8259C19.8077 11.4062 19.8122 10.7277 19.3862 10.3125L15.7612 6.74107C15.3353 6.32143 14.6466 6.32143 14.2252 6.74107L10.6002 10.3125H10.6047Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.b22964173b44a868e551b24f9345b678.svg";
export { ForwardRef as ReactComponent };